module.exports = __webpack_public_path__ + "static/okunowo-89b604d8a121e26608d5ecca5b155edf.png";